// features/orders/hooks/useOrderPrefetch.js
import { usePrefetch } from '../../../hooks/usePrefetch'
import { apiFetch } from '../../../api'

/**
 * Hook pour prefetch des détails de vente
 */
export function useOrderPrefetch() {
  const fetchOrderDetail = async (orderId) => {
    return await apiFetch(`/api/orders/${orderId}`)
  }

  const { prefetch, getFromCache, clearCache, invalidate } = usePrefetch(
    fetchOrderDetail,
    'orders'
  )

  return {
    prefetch: (orderId) => prefetch(orderId, { delay: 300 }), // Debounce hover
    getFromCache,
    clearCache,
    invalidate,
  }
}
